// Module
var code = "<template>\n  <require from=\"../../../../features/mooring/mooring-supplier-container\"></require>\n\n  <mooring-supplier-container></mooring-supplier-container>\n</template>\n";
// Exports
export default code;